var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtitle-div"},[_c('p',{staticClass:"subtitle-text"},[_vm._t("default")],2),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }